import { render } from "./AcceptCGUView.vue?vue&type=template&id=acbb5f36&scoped=true"
import script from "./AcceptCGUView.vue?vue&type=script&lang=js"
export * from "./AcceptCGUView.vue?vue&type=script&lang=js"

import "./AcceptCGUView.vue?vue&type=style&index=0&id=acbb5f36&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acbb5f36"]])

export default __exports__